import styled from 'styled-components';
import {GameItemTitleDefaultBox} from "./game-item-title.default.box";

export const GameItemTitleCasino777Box = styled(GameItemTitleDefaultBox)`
    font-size: 1.5rem;
`;